import api from '@/services/api'
import store from '../index'

export default {
  state: {},

  mutations: {},

  actions: {
    // Roles

    async saveRole({ commit }, data) {
      try {
        const { clientId } = store.getters.user

        return await api.post(`/${clientId}/roles`, data)
      } catch (error) {
        throw error
      }
    },

    async getRoles({ commit }) {
      try {
        const { clientId } = store.getters.user

        const response = await api.get(`/${clientId}/roles`)

        return response && response.data ? response.data : null
      } catch (error) {
        throw error
      }
    },

    async getRole({ commit }, roleId) {
      try {
        const { clientId } = store.getters.user

        const response = await api.get(`/${clientId}/roles/${roleId}`)

        return response && response.data ? response.data : null
      } catch (error) {
        throw error
      }
    },

    async updateRole({ commit }, role) {
      try {
        const { clientId } = store.getters.user

        return await api.put(`/${clientId}/roles/${role.id}`, role)
      } catch (error) {
        throw error
      }
    },

    async deleteRole({ commit }, roleId) {
      try {
        const { clientId } = store.getters.user

        return await api.delete(`/${clientId}/roles/${roleId}`)
      } catch (error) {
        throw error
      }
    },

    // Courses Role

    async addCourseRole({ commit }, data) {
      try {
        const { clientId } = store.getters.user

        return await api.post(
          `/${clientId}/roles/${data.roleId}/courses`,
          data.body,
        )
      } catch (error) {
        throw error
      }
    },

    async getCoursesRole({ commit }, roleId) {
      try {
        const { clientId } = store.getters.user

        const response = await api.get(`/${clientId}/roles/${roleId}/courses`)

        return response && response.data ? response.data : null
      } catch (error) {
        throw error
      }
    },

    async getCoursesUnrelatedRole({ commit }, roleId) {
      try {
        const { clientId } = store.getters.user

        const response = await api.get(
          `/${clientId}/roles/${roleId}/courses/unrelated`,
        )

        return response && response.data ? response.data : null
      } catch (error) {
        throw error
      }
    },

    async removeCourseRole({ commit }, data) {
      try {
        const { clientId } = store.getters.user

        return await api.delete(
          `/${clientId}/roles/${data.roleId}/courses/${data.courseId}`,
        )
      } catch (error) {
        throw error
      }
    },

    // Users Role

    async getUsersRole({ commit }, roleId) {
      try {
        const { clientId } = store.getters.user

        const response = await api.get(`/${clientId}/roles/${roleId}/users`)

        return response && response.data ? response.data : null
      } catch (error) {
        throw error
      }
    },
  },

  getters: {},
}
